import { FC, useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { useBillingPlansContext } from '@/entities/billing-plan';
import { useNotificationContext } from '@/features/notifications';
import { useHandleSubscription } from '@/shared/api';
import { useRouterContext } from '@/shared/router';
import { Col, Row } from '@/shared/ui';

type Props = {
  open: boolean;
  onSuccess: () => void;
  onCancel: () => void;
};

const { Title, Paragraph } = Typography;

export const FreePlanModal: FC<Props> = ({ open, onSuccess, onCancel }) => {
  const { showNotification } = useNotificationContext();
  const { activeOrganization } = useRouterContext();
  const { refetchPlans } = useBillingPlansContext();

  const [isLoading, setIsLoading] = useState(false);

  const { refetch: downgradeToFreePlan } = useHandleSubscription(
    {
      pathParams: {
        planType: 'Free',
        organizationId: activeOrganization?.id!,
        interval: 'Monthly',
      },
    },
    {
      enabled: false,
      onSuccess: () => {
        refetchPlans();
        setIsLoading(false);
        showNotification({
          message: 'Cancellation successfull',
          description:
            'You have successfully canceled your current plan and you will have Free plan after the current billing period ends.',
          type: 'success',
        });
        onSuccess();
      },
      onError: () => {
        setIsLoading(false);
      },
    },
  );

  const handleDowngrade = () => {
    setIsLoading(true);
    downgradeToFreePlan();
  };

  return (
    <Modal
      title={
        <Col
          alignItems="flex-start"
          style={{ margin: '10px 0', width: '100%' }}
        >
          <Title level={4} style={{ lineHeight: 1, marginTop: 15 }}>
            Downgrade to Free plan
          </Title>
        </Col>
      }
      destroyOnClose
      width={450}
      open={open}
      footer={null}
      style={{ maxWidth: '90%' }}
      onCancel={onCancel}
    >
      <Paragraph style={{ marginBottom: 20 }}>
        You are about to cancel your current plan and downgrade to Free plan.
        You will lose access to all the features of the current plan after the
        current billing period ends.
      </Paragraph>
      <Paragraph style={{ marginBottom: 20 }}>
        Are you sure you want to downgrade?
      </Paragraph>
      <Row justifyContent="flex-end" gap={15} style={{ marginTop: 30 }}>
        <Button size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          size="large"
          loading={isLoading}
          onClick={handleDowngrade}
        >
          Yes, downgrade to Free plan
        </Button>
      </Row>
    </Modal>
  );
};
